
(function() {
  var result = { translations: { "ko": { "i18n": { "duration": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84", "days": "{{ days }}\uC77C", "shortForm": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "days": "{{ days }}\uC77C", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} {{quarterNumber}}\uBD84\uAE30" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \uB0B4\uC120\uBC88\uD638: {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ko": "static-7.1189"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1189",
    "ar-eg": "static-7.1189",
    "bg": "static-7.1189",
    "bn": "static-7.1189",
    "ca-es": "static-7.1189",
    "cs": "static-7.1189",
    "da": "static-7.1189",
    "de": "static-7.1189",
    "el": "static-7.1189",
    "en-gb": "static-7.1189",
    "en": "static-7.1189",
    "es-mx": "static-7.1189",
    "es": "static-7.1189",
    "et": "static-7.1189",
    "fi": "static-7.1189",
    "fr-ca": "static-7.1189",
    "fr": "static-7.1189",
    "he-il": "static-7.1189",
    "hi": "static-7.1189",
    "hr": "static-7.1189",
    "hu": "static-7.1189",
    "id": "static-7.1189",
    "it": "static-7.1189",
    "ja": "static-7.1189",
    "ko": "static-7.1189",
    "lt": "static-7.1189",
    "ms": "static-7.1189",
    "nl": "static-7.1189",
    "no": "static-7.1189",
    "pl": "static-7.1189",
    "pt-br": "static-7.1189",
    "pt-pt": "static-7.1189",
    "ro": "static-7.1189",
    "ru": "static-7.1189",
    "sk": "static-7.1189",
    "sl": "static-7.1189",
    "sv": "static-7.1189",
    "th": "static-7.1189",
    "tl": "static-7.1189",
    "tr": "static-7.1189",
    "uk": "static-7.1189",
    "vi": "static-7.1189",
    "x-pseudo": "static-7.1189",
    "zh-cn": "static-7.1189",
    "zh-hk": "static-7.1189",
    "zh-tw": "static-7.1189"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ko', {version: 'static-7.1189'}); }
})();


